import React from 'react';
import FormHistory from 'modules/FormHistory';

const Products = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_da_products'
    : 'p_da_products';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;
};

export default Products;
